import { ApButtonStylingOption } from "components/Shared/ApButton";

export const ApButtonStyle1: ApButtonStylingOption = {
  btnBaseStyle: "Blue",
  borderRadiusStyle: "Rounded",
  horizontalPaddingStyle: "Large"
};

export const ApButtonStyle2: ApButtonStylingOption = {
  btnBaseStyle: "White",
  borderRadiusStyle: "Rounded",
  horizontalPaddingStyle: "Large"
};

export const ApButtonStyle3: ApButtonStylingOption = {
  btnBaseStyle: "White",
  borderRadiusStyle: "Normal",
  horizontalPaddingStyle: "Normal"
};

export const ApButtonStyle4: ApButtonStylingOption = {
  btnBaseStyle: "Blue",
  borderRadiusStyle: "Normal",
  horizontalPaddingStyle: "Normal"
};

export const ApButtonStyle5: ApButtonStylingOption = {
  btnBaseStyle: "Blue",
  borderRadiusStyle: "Rounded",
  horizontalPaddingStyle: "ExtraLarge"
};